
import { useParams } from 'react-router-dom'
import StrategyDetail from '../components/StrategyDetail'
import Navigation from '../components/Navigation'

export default function StrategyDetailPage() {
  const params = useParams()
  const strategyId = params.id as string

  return (
    <div className="min-h-screen animate-fadein">
      <Navigation />
      <StrategyDetail strategyId={strategyId} />
    </div>
  )
} 